import { state } from '../store/globalStore';
import { eventBus } from './eventBus';
import { psxUserWebBaseUrl } from './getConfigs';

const PSX_USER_WEB_URL_BASE = psxUserWebBaseUrl;

export const importPSXFraudUtils = async (component?: any) => {
  const psxFraudComponentUrl = `${PSX_USER_WEB_URL_BASE}/psx-user-web.esm.js`;
  const psxFraudUtilsModuleUrl = `${PSX_USER_WEB_URL_BASE}/psx-user-utility.esm.js`;

  // Listening to Fraud Check Completion to update User's Fraudulent status
  ['fraud.check.complete'].forEach(eventName => {
    eventBus.on(eventName, (data) => {
        state.isUserFraudulent = data?.isUserFraudulent;
    });
  });

  // Inject PSX Fraud Modules.

  if (!globalThis.PSX_FRAUD?.isPSXFraudModulesLoaded) {
    await import(psxFraudUtilsModuleUrl).then(async fraudUtilsModules => {
      if (fraudUtilsModules) {
        if (typeof globalThis.PSX_FRAUD === 'undefined') {
          globalThis.PSX_FRAUD = {
            isUserFraudulent: fraudUtilsModules.isUserFraudulent,
            userFraudInfo: fraudUtilsModules.userFraudInfo,
            isUserFraudulentEnhanced: fraudUtilsModules.isUserFraudulentEnhanced,
            userFraudInfoEnhanced: fraudUtilsModules.userFraudInfoEnhanced,
            isPSXFraudModulesLoaded: true,
          };
        } else {
          globalThis.PSX_FRAUD.isUserFraudulent = fraudUtilsModules.isUserFraudulent;
          globalThis.PSX_FRAUD.userFraudInfo = fraudUtilsModules.userFraudInfo;
          globalThis.PSX_FRAUD.isUserFraudulentEnhanced = fraudUtilsModules.isUserFraudulentEnhanced;
          globalThis.PSX_FRAUD.userFraudInfoEnhanced = fraudUtilsModules.userFraudInfoEnhanced;
          globalThis.PSX_FRAUD.isPSXFraudModulesLoaded = true;
        }        
      }
    });
  }

  // Inject PSX Fraud Component.
  if (!globalThis.PSX_FRAUD.isPSXFraudComponentLoaded) {
    const scriptComponentElement = document.createElement('script');
    scriptComponentElement.async = true;
    scriptComponentElement.type = 'module';
    scriptComponentElement.src = psxFraudComponentUrl;
    component.shadowRoot.appendChild(scriptComponentElement);
    globalThis.PSX_FRAUD.isPSXFraudComponentLoaded = true;
  }
}
